import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Injectable({
	providedIn: "root",
})
export class EncryptionService {
	private secretKey = "TuYYul&M134kYul";

	encrypt(value: string | number): string {
		if (value == null) {
			return null;
		}

		const encrypted = CryptoJS.AES.encrypt(
			value.toString(),
			this.secretKey
		).toString();

		return this.convertToUrlSafe(encrypted);
	}

	decrypt(encryptedValue: string): string | number {
		if (encryptedValue == null) {
			return null;
		}

		if (
			!isNaN(Number(encryptedValue)) &&
			isFinite(Number(encryptedValue))
		) {
			return Number(encryptedValue);
		}

		const decodedValue = this.convertFromUrlSafe(encryptedValue);
		const bytes = CryptoJS.AES.decrypt(decodedValue, this.secretKey);
		const decrypted = bytes.toString(CryptoJS.enc.Utf8);

		if (!isNaN(Number(decrypted))) {
			return Number(decrypted);
		}

		return decrypted;
	}

	encrypt2(value: string): string {
		if (value == null) {
			return null;
		}

		const encrypted = CryptoJS.AES.encrypt(
			value,
			this.secretKey
		).toString();
		return this.convertToUrlSafe(encrypted);
	}

	decrypt2(encryptedValue: string): string | number {
		if (encryptedValue == null) {
			return null;
		}

		if (
			!isNaN(Number(encryptedValue)) &&
			isFinite(Number(encryptedValue))
		) {
			return Number(encryptedValue);
		}

		const decodedValue = this.convertFromUrlSafe(encryptedValue);
		const bytes = CryptoJS.AES.decrypt(decodedValue, this.secretKey);
		return bytes.toString(CryptoJS.enc.Utf8);
	}

	encryptObject(data: object): string {
		const jsonString = JSON.stringify(data);
		const encrypted = CryptoJS.AES.encrypt(
			jsonString,
			this.secretKey
		).toString();
		return this.convertToUrlSafe(encrypted);
	}

	decryptObject(encryptedValue: string): any {
		if (!encryptedValue) return null;

		try {
			const decodedValue = this.convertFromUrlSafe(encryptedValue);
			const bytes = CryptoJS.AES.decrypt(decodedValue, this.secretKey);
			const decrypted = bytes.toString(CryptoJS.enc.Utf8);

			return JSON.parse(decrypted);
		} catch (error) {
			console.error("Error decrypting object:", error);
			return null;
		}
	}

	private convertToUrlSafe(value: string): string {
		return value.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
	}

	private convertFromUrlSafe(value: string): string {
		let base64 = value.replace(/-/g, "+").replace(/_/g, "/");
		while (base64.length % 4) {
			base64 += "=";
		}
		return base64;
	}
}
